// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { api } from '@/api/axios-instance';
import { parseResponse } from '@/api/parse-response';
import { responseMetadataSchema } from '@/api/types';
import { UpdateContactParameters, contactSchema } from '@/contact/api/types';
import { z } from 'zod';

const updateContactResponseSchema = z
  .object({
    data: contactSchema,
    metadata: responseMetadataSchema,
  })
  .transform(({ data, ...response }) => ({ ...response, contact: data }));

type UpdateContactResponse = z.infer<typeof updateContactResponseSchema>;

export async function updateContact(
  contactKey: string,
  parameters: UpdateContactParameters
): Promise<UpdateContactResponse> {
  const url = `/v1/contact/${contactKey}`;
  const response = await api.patch(url, parameters);

  return parseResponse(updateContactResponseSchema, response.data, {
    schemaName: 'UpdateContact',
    endpoint: url,
  });
}
